<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <div class="wow-form-header">
                    <div class="wow-form-header__icon"><mat-icon>payments</mat-icon></div>
                    <mat-card-title>
                        Contas à Pagar
                        <span class="cf-form-id" *ngIf="formulario.value.id"> — ID {{ formulario.value.id }}</span>
                    </mat-card-title>
                </div>
                <form [formGroup]="formulario" (ngSubmit)="submit()">
                    <app-conta-financeira-cadastro
                        [formulario]="formulario"
                        [baixaForm]="baixaForm"
                        [myControl]="myControl"
                        [pagadoresLista]="pagadoresLista"
                        [bloquearCampoEdicao]="bloquearCampoEdicao"
                        [config]="config"
                        [valorPago]="valorPago"
                        [valorRestante]="valorRestante"
                        [statusPagamento]="statusPagamento"
                        [baixas]="baixas"
                        [contaAberta]="contaAberta()"
                        [possuiAnexoFatura]="possuiAnexoFatura"
                        [possuiAnexoBaixa]="possuiAnexoBaixa"
                        [nomeArquivoFaturaSelecionado]="nomeArquivoFaturaSelecionado"
                        [nomeArquivoBaixaSelecionado]="nomeArquivoBaixaSelecionado"
                        [nomeArquivoFaturaSalvo]="nomeArquivoFaturaSalvo"
                        [temContaSalva]="!!formulario.value.id"
                        [segmentos]="segmentos"
                        (calcularTotal)="calcularValorTotal()"
                        (listarPagador)="listarPagador()"
                        (selecionarFatura)="onArquivoFatura($event)"
                        (selecionarComprovante)="onArquivoBaixa($event)"
                        (anexarFatura)="anexarFaturaConta()"
                        (registrarBaixa)="registrarBaixa()"
                        (baixarAnexo)="baixarAnexo($event)">
                    </app-conta-financeira-cadastro>
                    <div class="wow-form-acoes">
                        <button type="button" mat-stroked-button (click)="voltarConsulta()">
                            <mat-icon>arrow_back</mat-icon> Voltar
                        </button>
                        <button [disabled]="!formulario.valid || myControl.invalid" mat-raised-button color="primary" type="submit">
                            <mat-icon>save</mat-icon> Salvar
                        </button>
                    </div>
                </form>
            </mat-card>
        </div>
    </div>
</main>
